import { render, staticRenderFns } from "./DealerProfile.vue?vue&type=template&id=fedca2c2&scoped=true&"
import script from "./DealerProfile.vue?vue&type=script&lang=js&"
export * from "./DealerProfile.vue?vue&type=script&lang=js&"
import style0 from "./DealerProfile.vue?vue&type=style&index=0&id=fedca2c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fedca2c2",
  null
  
)

export default component.exports